import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  branches: null,
  business_info: null,
  settlement_bank: null,
  roles: null,
  users: null,
  merchant: null,
  cashbacks: null,
};

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setBranches: (state, action) => {
      state.branches = action.payload;
    },
    addBranch: (state, action) => {
      state.branches = [action.payload, ...state.branches];
    },
    editBranch: (state, action) => {
      const index = state.branches.findIndex(branch => +branch.id === +action.payload.id);
      if (index !== -1) {
        state.branches[index] = action.payload;
      }
    },
    deleteBranch: (state, action) => {
      state.branches = state.branches.filter(branch => +branch.id !== +action.payload);
    },
    setBusinessInfo: (state, action) => {
      state.business_info = action.payload;
    },
    setSettlementBank: (state, action) => {
      state.settlement_bank = action.payload;
    },
    setRoles: (state, action) => {
      state.roles = action.payload;
    },
    addRole: (state, action) => {
      state.roles = [action.payload, ...state.roles];
    },
    editRole: (state, action) => {
      const index = state.roles.findIndex(role => +role.id === +action.payload.id);
      if (index !== -1) {
        state.roles[index] = action.payload;
      }
    },
    deleteRole: (state, action) => {
      state.roles = state.roles.filter(role => +role.id !== +action.payload);
    },
    setUsers: (state, action) => {
      state.users = action.payload;
    },
    addUser: (state, action) => {
      state.users = [action.payload, ...state.users];
    },
    editUser: (state, action) => {
      const index = state.users.findIndex(user => +user.id === +action.payload.id);
      if (index !== -1) {
        state.users[index] = action.payload;
      }
    },
    deleteUser: (state, action) => {
      state.users = state.users.filter(user => +user.id !== +action.payload);
    },
    setMerchant: (state, action) => {
      state.merchant = action.payload;
    },
    setCashbacks: (state, action) => {
      state.cashbacks = action.payload;
    },
    addCashback: (state, action) => {
      state.cashbacks = [action.payload, ...state.cashbacks];
    },
    editCashback: (state, action) => {
      const index = state.cashbacks.findIndex(cashback => +cashback.id === +action.payload.id);
      if (index !== -1) {
        state.cashbacks[index] = action.payload;
      }
    },
    deleteCashback: (state, action) => {
      state.cashbacks = state.cashbacks.filter(cashback => +cashback.id !== +action.payload);
    }
  }
});

export const {
  setBranches,
  addBranch,
  editBranch,
  deleteBranch,
  setBusinessInfo,
  setSettlementBank,
  setRoles,
  addRole,
  editRole,
  deleteRole,
  setUsers,
  addUser,
  editUser,
  deleteUser,
  setMerchant,
  setCashbacks,
  addCashback,
  editCashback,
  deleteCashback
} = settingsSlice.actions;

export default settingsSlice.reducer;